import { render, staticRenderFns } from "./notice_confirm_dialog.vue?vue&type=template&id=05b072d6&scoped=true"
import script from "./notice_confirm_dialog.vue?vue&type=script&lang=js"
export * from "./notice_confirm_dialog.vue?vue&type=script&lang=js"
import style0 from "./notice_confirm_dialog.vue?vue&type=style&index=0&id=05b072d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b072d6",
  null
  
)

export default component.exports